const [SMALL, MID, LARGE] = ['100px', '150px', '250px'];
const [STRING, NUMBER, CURRENCY, LIST, HYPERLINK] = [
  'STRING', 'NUMBER', 'CURRENCY', 'LIST', 'HYPERLINK',
];
const [NOT_LIST, MAX_LIST_ELEMENTS_TO_SHOW, MAX_REASON_SET_TO_SHOW] = [0, 10, 15];

export const SingleColumn = (header, minWidth, varName, varType, sortable, defaultElementCount) => ({
    header,
    minWidth,
    varName,
    varType,
    sortable,
    defaultElementCount,
  });

export const CompanyTableMetaData = [
  SingleColumn('Day', SMALL, 'day', STRING, true, NOT_LIST),
  SingleColumn('Domain', SMALL, 'domain', STRING, true, NOT_LIST),
  SingleColumn('Name', SMALL, 'name', STRING, true, NOT_LIST),
  SingleColumn('Score Sum', SMALL, 'score_sum', NUMBER, true, NOT_LIST),
  SingleColumn('Reason Set', LARGE, 'reason_set', LIST, false, MAX_REASON_SET_TO_SHOW),
  SingleColumn('Description', LARGE, 'description', STRING, false, NOT_LIST),
  SingleColumn('Category List', LARGE, 'category_list', LIST, false, MAX_LIST_ELEMENTS_TO_SHOW),
  SingleColumn('Category Groups List', LARGE, 'category_groups_list', LIST, false, MAX_LIST_ELEMENTS_TO_SHOW),
  SingleColumn('Sector', SMALL, 'sector', STRING, true, NOT_LIST),
  SingleColumn('Industry Group', MID, 'industry_group', STRING, true, NOT_LIST),
  SingleColumn('Status', SMALL, 'status', STRING, true, NOT_LIST),
  SingleColumn('Company Type', SMALL, 'company_type', STRING, true, NOT_LIST),
  SingleColumn('Tags', LARGE, 'tags', LIST, false, MAX_LIST_ELEMENTS_TO_SHOW),
  SingleColumn('Facebook Handle', MID, 'facebook_handle', HYPERLINK, false, NOT_LIST),
  SingleColumn('Facebook Likes', MID, 'facebook_likes', NUMBER, true, NOT_LIST),
  SingleColumn('LinkedIn Handle', MID, 'linkedin_handle', HYPERLINK, false, NOT_LIST),
  SingleColumn('Twitter Handle', MID, 'twitter_handle', HYPERLINK, false, NOT_LIST),
  SingleColumn('Twitter Followers', MID, 'twitter_followers', NUMBER, true, NOT_LIST),
  SingleColumn('Twitter Following', MID, 'twitter_following', NUMBER, true, NOT_LIST),
  SingleColumn('Twitter Bio', LARGE, 'twitter_bio', STRING, false, NOT_LIST),
  SingleColumn('Crunchbase Handle', MID, 'crunchbase_handle', HYPERLINK, false, NOT_LIST),
  SingleColumn('City', SMALL, 'city', STRING, true, NOT_LIST),
  SingleColumn('State', SMALL, 'state', STRING, true, NOT_LIST),
  SingleColumn('Country', SMALL, 'country', STRING, true, NOT_LIST),
  SingleColumn('Country Code', SMALL, 'country_code', STRING, true, NOT_LIST),
  SingleColumn('Time Zone', SMALL, 'timezone', STRING, true, NOT_LIST),
  SingleColumn('Employees Range', MID, 'employees_range', STRING, true, NOT_LIST),
  SingleColumn('Estimated Annual Revenue Range', MID, 'estimated_annual_revenue_range', STRING, false, NOT_LIST),
  SingleColumn('Number of Funding Rounds', MID, 'num_funding_rounds', NUMBER, true, NOT_LIST),
  SingleColumn('Total Funding (USD-$)', MID, 'total_funding_usd', CURRENCY, true, NOT_LIST),
  SingleColumn('Founded On', MID, 'founded_on', STRING, true, NOT_LIST),
  SingleColumn('Last Funding On', MID, 'last_funding_on', STRING, true, NOT_LIST),
  SingleColumn('Number of Exits', MID, 'num_exits', NUMBER, true, NOT_LIST),
  SingleColumn('Techs', LARGE, 'tech', LIST, false, MAX_LIST_ELEMENTS_TO_SHOW),
  SingleColumn('Number of Pages', MID, 'number_of_pages', NUMBER, true, NOT_LIST),
  // job_count, job_title_set, job_location_set, job_work_place_set, job_schedule_set, job_post_time_set
  SingleColumn('Job Count', SMALL, 'job_count', NUMBER, true, NOT_LIST),
  SingleColumn('Job Titles', LARGE, 'job_title_set', LIST, false, MAX_LIST_ELEMENTS_TO_SHOW),
  SingleColumn('Job Locations', LARGE, 'job_location_set', LIST, false, MAX_LIST_ELEMENTS_TO_SHOW),
  SingleColumn('Job Workplace Types', LARGE, 'job_work_place_set', LIST, false, MAX_LIST_ELEMENTS_TO_SHOW),
  SingleColumn('Job Schedules', LARGE, 'job_schedule_set', LIST, false, MAX_LIST_ELEMENTS_TO_SHOW),
  SingleColumn('Job Post Times', LARGE, 'job_post_time_set', LIST, false, MAX_LIST_ELEMENTS_TO_SHOW),
];

export const ContactTableMetaData = [
  SingleColumn('Date', SMALL, 'dt', STRING, true, NOT_LIST),
  SingleColumn('Domain', SMALL, 'domain', STRING, true, NOT_LIST),
  SingleColumn('Name', SMALL, 'name', STRING, true, NOT_LIST),
  SingleColumn('Title', SMALL, 'title', STRING, true, NOT_LIST),
  SingleColumn('Industry', MID, 'industry', STRING, true, NOT_LIST),
  SingleColumn('Email', LARGE, 'email', STRING, false, NOT_LIST),
  SingleColumn('Phone Number', MID, 'phone_number', STRING, false, NOT_LIST),
  SingleColumn('Country', SMALL, 'country', STRING, true, NOT_LIST),
  SingleColumn('Region', SMALL, 'region', STRING, true, NOT_LIST),
  SingleColumn('State', SMALL, 'state', STRING, true, NOT_LIST),
  SingleColumn('City', SMALL, 'city', STRING, true, NOT_LIST),
];

